import { Pipe, PipeTransform } from '@angular/core';
import { toWords } from 'number-to-words';

@Pipe({
    name: 'toWords',
  standalone: false
})
export class ToWordsPipe implements PipeTransform {
  transform(value: any) {
    let asNumber = Number(value);
    if (isNaN(asNumber)) {
      return '' + value;
    }

    return toWords(asNumber);
  }
}
